import _defineProperty from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { importJWK } from '../key/import.js';
import isObject from '../lib/is_object.js';
import { JWSInvalid } from '../util/errors.js';
export function EmbeddedJWK(_x, _x2) {
  return _EmbeddedJWK.apply(this, arguments);
}

function _EmbeddedJWK() {
  _EmbeddedJWK = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(protectedHeader, token) {
    var joseHeader, key;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            joseHeader = _objectSpread(_objectSpread({}, protectedHeader), token.header);

            if (isObject(joseHeader.jwk)) {
              _context.next = 3;
              break;
            }

            throw new JWSInvalid('"jwk" (JSON Web Key) Header Parameter must be a JSON object');

          case 3:
            _context.next = 5;
            return importJWK(_objectSpread(_objectSpread({}, joseHeader.jwk), {}, {
              ext: true
            }), joseHeader.alg, true);

          case 5:
            key = _context.sent;

            if (!(key instanceof Uint8Array || key.type !== 'public')) {
              _context.next = 8;
              break;
            }

            throw new JWSInvalid('"jwk" (JSON Web Key) Header Parameter must be a public key');

          case 8:
            return _context.abrupt("return", key);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _EmbeddedJWK.apply(this, arguments);
}